var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterchain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0065 7.11595C17.1021 6.93362 17.3638 6.9386 17.4524 7.12444L23.6812 20.19C23.7138 20.2584 23.7138 20.338 23.6811 20.4064L17.4276 33.4978C17.3388 33.6837 17.0767 33.6883 16.9815 33.5056L10.1585 20.4159C10.1205 20.343 10.1206 20.256 10.1588 20.1832L17.0065 7.11595Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4968 7.11595C22.5923 6.93362 22.8541 6.9386 22.9427 7.12444L29.1715 20.19C29.2041 20.2584 29.204 20.338 29.1714 20.4064L22.9178 33.4978C22.829 33.6837 22.567 33.6883 22.4717 33.5056L15.6488 20.4159L14.9855 20.7643L15.6488 20.4159C15.6108 20.343 15.6109 20.256 15.649 20.1832L22.4968 7.11595Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterchain);
export default __webpack_public_path__ + "static/media/interchain.34358573413e3dcf0c8f9c327000980c.svg";
export { ForwardRef as ReactComponent };